// extracted by mini-css-extract-plugin
module.exports = {"root":"speakers_root__AkH9K","speakers":"speakers_speakers__5kyhb"};